const product = {
  product: "Product",
  products: "Products",
  information: "Information",
  additionalInformation: "Additional Information",
  contactUs: "Contact Us",
  contactUsText: "Want to customise your tour or have any other questions?",
  dropUsAnEmail: "Drop us an email",
  viewLess: "View less",
  viewMore: "View more",
  less: "less",
  more: "more",
  highlights: "Highlights",
  inclusions: "Inclusions",
  exclusions: "Exclusions",
  pleaseWait: "Please wait...",
  tourType: "Tour Type",
  search: "Search",
  available: "Available",
  availableTours: "Available Tours",
  sortBy: "SORT BY",
  priceLowToHigh: "Price: Low to High",
  priceHighToLow: "Price: High to Low",
  mostPopular: "Most Popular",
  roomOnly: "Room Only",
  bedAndBreakfast: "Bed & Breakfast",
  halfBoard: "Half Board",
  fullBoard: "Full Board",
  allInclusive: "All Inclusive",
  viewDetails: "View Details",
  close: "Close",
  at: "At", // At dat,
  person: "person",
  cancellationPolicy: "Cancellation Policy",
  cancellationIs: "cancellation is",
  to: "To",
  bookingRemarks: "Booking Remarks",
  totalPrice: "Total Price",
  back: "Back",
  bookNow: "Book Now",
  minutes: "Minutes",
  visitDuration: "Visit Duration",
  itinerary: "Itinerary",
  airportToHotel: "Airport to Hotel",
  hotelToAirport: "Hotel to Airport",
  details: "details",
  servicesDetails: "Services Details",
  services: "Services",
  day: "Day",
  next: "Next",
  nextStep: "Next Step",
  skip: "Skip",
  remarks: "Remarks",
  optional: "optional",
  guests: "Guests",
  payment: "Payment",
  pickup: "pickup",
  featuredPackage: "Featured Package",
  flights: "Flights",
  accommodation: "Accommodation",
  transfers: "Transfers",
  tours: "Tours",
  experiences: "Experiences",
  featuredTour: "Featured Tour",
  From: "From",
  Accommodation: "Accommodation",
  approxDuration: "Approx. duration",
  travellerInformation: "Traveller Information",
  bookingOverview: "Booking Overview",
  checkout: "Checkout",
  paymentFailed: "Payment Failed",
  paymentSuccess: "Payment Success",
  night: "Night",
  nights: "Nights",
  viewEscapes: "View Escape",
  viewExperience: "View Experience",
  escapeType: "Escape Type",
  adultsOnly: "Adults Only",
  totalDuration: "Total Duration",
  options: "Options",
  departingAirport: "Departing Airport",
  childrenAreNotAllowedInThisTour: "Children are not allowed in this tour",
};

export default product;
